module.exports = __webpack_public_path__ + "static/Chris-2dd597226f8a25fbd5e92a407575728c.jpg";